/**
 * The department page's binding of the shared detail-page surface.
 *
 * Its pane BODIES come from `Teams/surface` - one org pane set for both
 * records. What is particular to a department is its config (`./layout`) and
 * one typed hook over the generic selection-free one.
 */

import {
  useSurfaceWithoutSelection,
  UseDetailSurfaceOptions,
  UseSurfaceWithoutSelectionResult,
} from '../../../shared/surface/useDetailSurface';
import {
  DEPARTMENT_SURFACE,
  DEPARTMENT_TABS,
  DepartmentPanelId,
  DepartmentTab,
} from './layout';
import { OrgReaderContent } from '../../Shared/OrgSurfaceContext';

export { DEPARTMENT_SURFACE, DEPARTMENT_TABS };
export type { DepartmentPanelId, DepartmentTab };

export type DepartmentWorkspace = UseSurfaceWithoutSelectionResult<
  DepartmentPanelId,
  OrgReaderContent,
  DepartmentTab
>;

/** Keyed by department uuid - each remembers its own arrangement. */
export const useDepartmentWorkspace = (
  departmentId: string,
  options: Omit<UseDetailSurfaceOptions<DepartmentTab>, 'entityId'> = {}
): DepartmentWorkspace =>
  useSurfaceWithoutSelection<DepartmentPanelId, OrgReaderContent, DepartmentTab>(DEPARTMENT_SURFACE, {
    ...options,
    entityId: departmentId,
  });
